import { useEffect } from "react";
import axios from "axios";
import i18n, { SUPPORTED_LANGS } from "@/i18n";
import { API } from "@/data/catalog";

export const CountryLanguage = () => {
  useEffect(() => {
    const manual = () => Boolean(localStorage.getItem("i18nextLng")) || new URLSearchParams(window.location.search).has("lang");
    if (manual()) return;
    let active = true;
    const choose = (data) => { if (active && !manual() && SUPPORTED_LANGS.includes(data.language)) i18n.changeLanguage(data.language); };
    let cached;
    try { cached = JSON.parse(sessionStorage.getItem("if_country_language") || "null"); } catch { cached = null; }
    if (cached?.expires > Date.now()) choose(cached);
    else axios.get(`${API}/public/locale`, { timeout:3500 }).then(({ data }) => { sessionStorage.setItem("if_country_language", JSON.stringify({ ...data, expires:Date.now() + 3600000 })); choose(data); }).catch(() => {});
    return () => { active = false; };
  }, []);
  return null;
};